var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#34363D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.541V21.8689L19.093 20.174L22.1047 21.9899L18.9709 23.6847V27.3569L16 25.541Z",
    fill: "#E9B941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9709 29.9395L16 28.2043V38.0101L24.4651 42.8121V39.3821L18.9709 36.2346V29.9395Z",
    fill: "#E9B941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9593 14L21.5349 18.8424L24.5058 20.4968L29.9593 17.3897L35.4535 20.4968L38.3837 18.8424L29.9593 14Z",
    fill: "#E9B941"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5349 28.7289V25.1375L24.5058 23.3619L29.9593 26.4691L35.4535 23.3619L38.5058 25.1375V28.7289L33.093 31.7957V38.0101L29.9593 39.7856L26.8256 38.0101V31.7957L21.5349 28.7289Z",
    fill: "#E9B941"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9593 20.2547L26.9477 21.9899L29.9593 23.7251L33.0523 21.9899L29.9593 20.2547Z",
    fill: "#E9B941"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8256 20.174L37.8547 21.9899L40.8256 23.6847V27.3569L44 25.5813V21.9899L40.8256 20.174Z",
    fill: "#E9B941"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28.2043L40.8256 29.9395V36.2346L35.4535 39.3821V42.8121L44 38.0101V28.2043Z",
    fill: "#E9B941"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4535 36.6784V33.087L38.5058 31.4729V34.9433L35.4535 36.6784Z",
    fill: "#E9B941"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3314 31.4729L24.5058 33.087L24.4651 36.6784L21.3314 34.9433V31.4729Z",
    fill: "#E9B941"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9593 42.5296L26.8256 40.7541V44.1438L29.9593 46L33.093 44.1438V40.7541L29.9593 42.5296Z",
    fill: "#E9B941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.2caf23c504bd8feb5635b46066d3e2b6.svg";
export { ForwardRef as ReactComponent };